// extracted by mini-css-extract-plugin
export default {"userProfile":"styles_userProfile__pzYyS"};